import { Guid } from '@ups/xplat/core';

export class ItemListDTO {
  itemId: string;
  itemName: string;
  manufacturerName: string;
  manufacturerPartNumber: string;

  constructor() {
    this.itemId = Guid.empty;
    this.itemName = '';
    this.manufacturerName = '';
    this.manufacturerPartNumber = '';
  }
}
